import {HttpCrudDataSource} from '../../core/data-source/http-crud.data-source';

export class TerritoryGroupCrudDataSource<T> extends HttpCrudDataSource<T> {
    protected apiPath: string = '/gt/gt-api/scheduling-zone-groups';
}
